<template>
  <el-footer class="footer" height="auto">
    <div class="index-container">
      <div class="footer-head wow fadeInUp" data-wow-delay=".2s">
        <img src="../assets/img/logo.png" class="logo" alt="logo">
        <div class="footer-nav">
          <div class="footer-nav-item">
            <router-link to="/">首页</router-link>
          </div>
          <div class="footer-nav-item">
            <router-link to="/service/1">产品服务</router-link>
          </div>
          <!-- <div class="footer-nav-item">
            <router-link to="/">方案中心</router-link>
          </div> -->
          <div class="footer-nav-item">
            <router-link to="/news">资讯动态</router-link>
          </div>
          <div class="footer-nav-item">
            <router-link to="/AboutUs">关于到位</router-link>
          </div>
        </div>
      </div>
      <div class="footer-body">
        <div class="left">
          <div class="left-content1" data-wow-delay=".2s">
            <p class="des">运营总部：深圳市宝安区西乡街道南昌社区新零售产业园C座5楼</p>
            <p class="des">研发总部：西安市雁塔区科技二路清华科技园K座2406</p>
            <p class="des">邮箱：ezzloc@daovay.com</p>
            <p class="des"><a style="color:grey;" href="https://beian.miit.gov.cn">© 2016 - {{nowYear}} - 深圳市到位科技有限公司 版权所有 粤ICP备16092101号-1</a></p>
          </div>
          <!-- <div class="left-content1 wow fadeInUp" data-wow-delay=".4s">
            <img src="~assets/img/hezuo.png" alt="" width="25">
            <p class="title">合作咨询</p>
            <p class="phone">{{ info.workNumber }}</p>
          </div> -->
          <div class="left-content1 " data-wow-delay=".6s">
            <img src="../assets/img/fuwu.png" alt="" width="25">
            <p class="title">服务热线</p>
            <p class="phone">400-008-5056</p>
          </div>
          <div class="left-content1" data-wow-delay=".6s">
            <img src="../assets/img/shijian.png" alt="" width="25">
            <p class="title">服务时间</p>
            <p class="time">周一至周五9:00-18:00</p>
          </div>
        </div>
        <div class="right" data-wow-delay=".8s">
          <img src="../assets/img/wx.jpg" alt="微信服务号" class="img">
          <p class="des">微信服务号</p>
        </div>
      </div>
    </div>
 
  </el-footer>
</template>

<script>
export default {
  name: "v-footer",
  data () {
    return {
      nowYear:'',
    }
  },
  mounted () {
    var myDate = new Date();
    this.nowYear = myDate.getFullYear();
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.footer {
  position: relative;
  overflow: hidden;
  z-index: 10;
  background:#06060b url('../assets/img/foot_back.jpg') no-repeat center center ;
  background-size: 100% 100%;
   @media only screen and (min-width: 768px){
    .index-container {
      display: block;
      width:90%;
      margin:0 auto;
      padding-bottom: 30px;
      .footer-head {
        padding: 30px 0;
        border-bottom: 1px solid #242424;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .logo{
          height:60px;
        }
        .footer-nav {
          overflow: hidden;
          margin: 0 -25px;
          /*display: flex;*/
          /*justify-content: space-between;*/
          .footer-nav-item {
            padding: 0 25px;
            float: left;
            a {
              color: #999;
              text-decoration: none;
              font-size: 17px;
            }
          }
        }
      }
      .footer-body {
        margin-top: 35px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          overflow: hidden;
          margin: 0 -35px;
          .left-content1 {
            display: flex;
            padding: 0 35px;
            border-right: 1px solid #242424;
            flex-direction: column;
            color: #fff;
            &:last-child {
              border-right: none;
            }
            .des {
              padding: 12.5px 0;
              color: #808080;
              line-height: 1;
              font-size: 14px;
            }
            .title {
              font-size: 14px;
              color: #808080;
              padding: 15px 0 20px;
            }
            .phone {
              font-size: 22px;
              color: #ccc;
            }
            .time {
              font-size: 22px;
              color: #ccc;
            }
          }
        }
        .right {
          width: 130px;
          .img {
            width: 100%;
            display: block;
          }
          .des {
            font-size: 12px;
            color: #666;
            padding-top: 15px;
            text-align: center;
          }
        }
      }
    }
    
  }
}
</style>
